import { useDict } from '../i18n/dictionary';
import { shell } from '../i18n/shell';

export function Landing() {
  const t = useDict(shell);
  return (
    <main className="landing-hero">
      <div className="landing-content">
        <h1 className="wordmark-lg">
          IT<span className="wordmark-accent">Lamb</span>
        </h1>
        <div className="divider"></div>
        <p className="landing-subtitle">{t.landingSubtitle}</p>
      </div>
    </main>
  );
}
